import { render, staticRenderFns } from "./commissionDeclareZJ.vue?vue&type=template&id=0338e9b7"
import script from "./commissionDeclareZJ.vue?vue&type=script&lang=js"
export * from "./commissionDeclareZJ.vue?vue&type=script&lang=js"
import style0 from "./commissionDeclareZJ.vue?vue&type=style&index=0&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports